import { Skeleton, Tooltip } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Avatar, AvatarGroup } from 'components/atoms/avatar';
import { Button } from 'components/atoms/button';
import { Option } from '../followers.interface';
import { getSelectedOptions } from '../followers.utils';
import styles from './content.module.css';

interface Props {
  value: string[];
  options: Option[];
  size: SizeType;
}

const SelectedUserOrTeam: FC<Props> = (props) => {
  const { value, options } = props;
  const selectedOptions = getSelectedOptions(value, options);

  return (
    <AvatarGroup className={styles.avatar_group} maxCount={2}>
      {selectedOptions.map((opt) => (
        <Avatar
          key={opt.value}
          name={opt.name || opt.email}
          src={opt.photoUrl}
          companyLogoUrl={opt.companyLogo}
          size="small"
        />
      ))}
    </AvatarGroup>
  );
};

interface ContentProps {
  ref: React.Ref<HTMLSelectElement>;
  disabled?: boolean;
  loading?: boolean;
  placeholder?: React.ReactNode;
  selected: string[] | string;
  options: Option[];
  mode: 'button' | 'icon';
  buttonIcon: React.ReactNode;
  size?: SizeType;
  onClick: () => void;
  tooltipTitle?: React.ReactNode;
}
export const Content: FC<ContentProps> = React.forwardRef((props, ref) => {
  const {
    selected = [],
    options,
    mode,
    buttonIcon,
    size,
    onClick,
    placeholder,
    disabled = false,
    tooltipTitle,
    loading = false,
  } = props;

  if (mode === 'icon') {
    return (
      <Tooltip title={tooltipTitle}>
        <Button
          disabled={disabled}
          ref={ref}
          type="text"
          icon={buttonIcon}
          size={size}
          onClick={() => onClick()}
        />
      </Tooltip>
    );
  }
  const hasValue = selected.length;
  let buttonContent;

  if (hasValue) {
    buttonContent = (
      <SelectedUserOrTeam
        size={size}
        value={Array.isArray(selected) ? selected : [selected]}
        options={options}
      />
    );
  } else if (placeholder) {
    buttonContent = placeholder;
  } else {
    buttonContent = <FormattedMessage id="choose" />;
  }

  return loading ? (
    <Skeleton className={styles.loading} />
  ) : (
    <Button
      ref={ref}
      size={size}
      type={hasValue ? 'text' : 'link'}
      icon={!hasValue && buttonIcon}
      onClick={() => onClick()}
      disabled={disabled}
    >
      {buttonContent}
    </Button>
  );
});
